module.exports = __webpack_public_path__ + "media/images/my_trailhead/my_trailhead_for_salesforce-12f9334e815cb4156c602be9b624f75a.svg";